import { render, staticRenderFns } from "./ShortcutsAndVoiceCommandsModal.vue?vue&type=template&id=6e13e483&"
import script from "./ShortcutsAndVoiceCommandsModal.vue?vue&type=script&lang=js&"
export * from "./ShortcutsAndVoiceCommandsModal.vue?vue&type=script&lang=js&"
import style0 from "./ShortcutsAndVoiceCommandsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports